<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
		
      <div class="dlblock-mb20 mr10">
        <span class="pr5">编号</span>
        <el-input v-model.trim="id" placeholder="请输入商户编号" style="width: 150px;"/>
      </div>

    <!-- <div class="dlblock-mb20 mr10">
        <span class="pr5">二级商户名称</span>
        <el-input v-model.trim="subMerName" placeholder="请输入商户名称" style="width: 150px;"/>
      </div> -->
	  
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="date"
	        style="width: 300px;"
	        type="daterange"
	        value-format="yyyy-MM-dd HH:mm:ss"
	        range-separator="至"
	        start-placeholder="开始日期"
	        end-placeholder="结束日期"/>
	  </div>
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getSnhMerchantPageFn()">
          搜索
        </el-button>
      </div>
	   
	   <div class="dlblock-mb20 mr10">
	     <el-button type="primary" @click="editBtn(49, dialogMore.moreRow)">
	       企业网银充值(活动)
	     </el-button>
	   </div>
	   
	   <div class="dlblock-mb20 mr10">
	     <el-button type="primary" @click="editBtn(50, dialogMore.moreRow)">
	       企业网银充值(垫资)
	     </el-button>
	   </div>
	   
    </el-row>

	<br>
	
    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="id" label="编号"></el-table-column>
	  <el-table-column align="center" prop="trxAmount" label="入金金额"></el-table-column>
	  <el-table-column align="center" prop="operationUserId" label="操作人用户id"></el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	  <el-table-column align="center" prop="stateStr" label="状态"></el-table-column>
	 
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="{row}">
		  <a class="glob-a"  @click="editBtn(17, row)">更多</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
	<!-- 更多 -->
	<el-dialog title="更多" :visible.sync="dialogMore.modal" width="600px">
	  
	   <!-- {{dialogMore.moreRow}} -->
	    
		 <!--   <a class="glob-a"  @click="editBtn(2, dialogMore.moreRow)">修改</a> -->
		    <!--  <a class="glob-a"  @click="editBtn(8, dialogMore.moreRow)">查看</a> -->
			<!--  <a class="glob-a"  @click="editBtn(18, dialogMore.moreRow)">同步old</a>
				  <a class="glob-a"  @click="editBtn(20, dialogMore.moreRow)">同步new</a>
				  <a class="glob-a"  @click="editBtn(9, dialogMore.moreRow)">签约短信验证码重发</a>
				  <a class="glob-a"  @click="editBtn(7, dialogMore.moreRow)">签约</a>
				  <a class="glob-a"  @click="editBtn(6, dialogMore.moreRow)">状态变更</a>
				  <a class="glob-a"  @click="editBtn(10, dialogMore.moreRow)">余额查询</a>
				  <a class="glob-a"  @click="editBtn(11, dialogMore.moreRow)">身份验证(非页面跳转)</a>
				  <a class="glob-a"  @click="editBtn(12, dialogMore.moreRow)">身份验证(页面跳转)</a>
				  <a class="glob-a"  @click="editBtn(13, dialogMore.moreRow)">授权支付签约(银行端)</a>
				  <a class="glob-a"  @click="editBtn(14, dialogMore.moreRow)">授权支付签约(商户端)—申请</a>
				  <a class="glob-a"  @click="editBtn(15, dialogMore.moreRow)">授权支付签约(商户端)—确认</a>
				  <a class="glob-a"  @click="editBtn(16, dialogMore.moreRow)">授权支付签约(商户端)—验证码重发</a>
				  <a class="glob-a"  @click="editBtn(19, dialogMore.moreRow)">掌银被扫支付请求</a>
				  <a class="glob-a"  @click="editBtn(21, dialogMore.moreRow)">授权支付签约/解约结果查询</a>
				  <a class="glob-a"  @click="editBtn(22, dialogMore.moreRow)">授权支付解约</a>
				  <a class="glob-a"  @click="editBtn(26, dialogMore.moreRow)">预授权确认/取消</a>
				  <a class="glob-a"  @click="editBtn(31, dialogMore.moreRow)">第三方POS对账单下载</a>
				  <a class="glob-a"  @click="editBtn(30, dialogMore.moreRow)">二级商户迁移</a>
				  <a class="glob-a"  @click="editBtn(32, dialogMore.moreRow)">查询POS（二级）商户T日清算金额</a>
				  
				  <a class="glob-a"  @click="editBtn(36, dialogMore.moreRow)">单笔退款</a>
				  <a class="glob-a"  @click="editBtn(37, dialogMore.moreRow)">单笔交易查询</a>
				  
				  
				  <a class="glob-a"  @click="editBtn(5, dialogMore.moreRow)">删除</a> -->

	</el-dialog>
	
	<!-- 6.35	二级商户余额查询 查看 -->
	<el-dialog title="查看" :visible.sync="dialogMerchantBalance.modal" width="900px">
		<el-form label-width="160px">
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="商户编号：">
		        {{dialogMerchantBalance.data.merchant.merchantID}}
		      </el-form-item>
		    </el-col>
		    <el-col :span="12">
		      <el-form-item label="综合商户名称：">
		        {{dialogMerchantBalance.data.trxResponse.merchantName}}
		      </el-form-item>
		    </el-col>
		  </el-row>
		  <el-row>
		    <el-col :span="12">
		      <el-form-item label="余额：">
		        {{dialogMerchantBalance.data.trxResponse.balance}}
		      </el-form-item>
		    </el-col>
			<el-col :span="12">
				<el-form-item label="二级商户号：">
				  {{dialogMerchantBalance.data.trxResponse.subMerId}}
				</el-form-item>
			</el-col>
		  </el-row>
		   <el-row>
			   <el-col :span="12">
			     <el-form-item label="出金号：">
			       {{dialogMerchantBalance.data.trxResponse.subMerchantAccNo}}
			     </el-form-item>
			   </el-col>
		   </el-row>
		</el-form> 
	</el-dialog>

    <!-- 6.45	二级商户信息查询 查看 -->
    <el-dialog title="查看" :visible.sync="auditShow.modal" width="900px">
      <el-form label-width="160px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台商户名称：">
              {{auditShow.data.merchantName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级商户编号：">
              {{auditShow.data.subMerId}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="二级商户名称：">
              {{auditShow.data.subMerName}}
            </el-form-item>
          </el-col>
		  <el-col :span="12">
		    <el-form-item label="排序方式：">
		      {{auditShow.data.subMerSort}}
		    </el-form-item>
		  </el-col>
        </el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户类型：">
		      {{auditShow.data.subMerchantType}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件类型：">
		      {{auditShow.data.CertificateType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人证件编号：">
		      {{auditShow.data.certificateNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="法定代表人或负责人名称：">
		      {{auditShow.data.contactName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="银行预留手机号：">
		      {{auditShow.data.merMobileNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="状态：">
		      {{auditShow.data.status}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="二级商户状态说明：">
		      {{auditShow.data.statusMessage}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业证件类型：">
		      {{auditShow.data.companyCertType}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="企业证件号码：">
		      {{auditShow.data.companyCertNo}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="企业联系人名称：">
		      {{auditShow.data.companyName}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-row>
		  <el-col :span="12">
		    <el-form-item label="通知地址：">
		      {{auditShow.data.notifyUrl}}
		    </el-form-item>
		  </el-col>
		  <el-col :span="12">
		    <el-form-item label="审核状态：">
		      {{auditShow.data.isPassed}}
		    </el-form-item>
		  </el-col>
		</el-row>
		
		<el-table class="my-table" :data="auditShow.data.subAccountRecords" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
		  <el-table-column align="center" prop="accountType" label="账户类型"></el-table-column>
		  <el-table-column align="center" prop="accountName" label="账户名称"></el-table-column>
		  
		  <el-table-column align="center" prop="mobilePhone" label="二级商户手机号"></el-table-column>
		  <el-table-column align="center" prop="account" label="账户号"></el-table-column>
		  
		  <el-table-column align="center" prop="accountAbisNo" label="行内6网点号"></el-table-column>
		  <el-table-column align="center" prop="bankNo" label="账户开户行"></el-table-column>
		  
		  <el-table-column align="center" prop="accStatus" label="账户状态"></el-table-column>
		  <el-table-column align="center" prop="isABCAccount" label="是否是农行账号"></el-table-column>
		    
		</el-table>
		
		
      </el-form>
    </el-dialog>
	
	<!-- 6.53	二级商户签约短信验证码重发 -->
	<el-dialog title="商户签约短信验证码重发" :visible.sync="signUpSMS.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signUpSMS.subMerchantAccNo" placeholder="请输入出金卡号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signUpSMS.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signUpSMSBtn">确 定</el-button>
	  </div>
	</el-dialog>


	<!-- 二级商户入金交易活动 -->
	<el-dialog title="二级商户入金交易活动" :visible.sync="secondaryMerchantsPaymentTransaction.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="金额：">
	    <el-input v-model.trim="secondaryMerchantsPaymentTransaction.amountOfMoney" placeholder="金额"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="secondaryMerchantsPaymentTransaction.modal = false">取 消</el-button>
	    <el-button type="primary" @click="secondaryMerchantsPaymentTrans">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 二级商户入金交易垫资 -->
	<el-dialog title="二级商户入金交易垫资" :visible.sync="secondaryMerchantsPaymentTransactionAdvanceFunds.modal" width="400px">
	  <el-form label-width="120px">
	  <el-form-item label="金额：">
	    <el-input v-model.trim="secondaryMerchantsPaymentTransactionAdvanceFunds.amountOfMoney" placeholder="金额"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="secondaryMerchantsPaymentTransactionAdvanceFunds.modal = false">取 消</el-button>
	    <el-button type="primary" @click="secondaryMerchantsPaymentTransAdvanceFunds">确 定</el-button>
	  </div>
	</el-dialog>
	
  <!-- 新增编辑 -->
    <el-dialog :title="editData.add === 1 ? '新增商户' : '编辑商户'" :visible.sync="editData.modal" width="800px">
      <el-form label-width="220px">
        <el-form-item label="二级商户名称：">
          <el-input v-model.trim="editData.subMerName" placeholder="请输入二级商户名称"/>
        </el-form-item>
        <el-form-item label="二级商户类型：">
			<el-select v-model="editData.subMerType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in subMerTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
        </el-form-item>
  <!-- <el-form-item label="排序方式：">
		  <el-input v-model.trim="editData.subMerSort" placeholder="请输入排序方式"/>
		</el-form-item> -->
		<el-form-item label="法定代表人或负责人证件类型：">
			<el-select v-model="editData.certificateType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in certificateTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="法定代表人或负责人证件编号：">
		  <el-input v-model.trim="editData.certificateNo" placeholder="请输入法定代表人或负责人证件编号"/>
		</el-form-item>
		<el-form-item label="法定代表人或负责人名称：">
		  <el-input v-model.trim="editData.contactName" placeholder="请输入法定代表人或负责人名称"/>
		</el-form-item>
		<el-form-item label="企业名称：">
		  <el-input v-model.trim="editData.companyName" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="企业证件类型：">
			<el-select v-model="editData.companyCertType" class="w150" placeholder="企业商户必选" clearable>
			  <el-option v-for="(item, index) in companyCertTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="企业证件编号：">
		  <el-input v-model.trim="editData.companyCertNo" placeholder="企业商户必输"/>
		</el-form-item>
		<el-form-item label="收款户名：">
		  <el-input v-model.trim="editData.accountName" placeholder="请输入收款户名"/>
		</el-form-item>
		<el-form-item label="收款账号：">
		  <el-input v-model.trim="editData.account" placeholder="请输入收款账号"/>
		</el-form-item>
		<el-form-item label="收款银行：">
		  <el-input v-model.trim="editData.bankName" placeholder="请输入收款银行"/>
		</el-form-item>
		<el-form-item label="银行预留手机号：">
		  <el-input v-model.trim="editData.mobilePhone" placeholder="请输入银行预留手机号"/>
		</el-form-item>
		<el-form-item label="地址：">
		  <el-input v-model.trim="editData.address" placeholder="非必须"/>
		</el-form-item>
		<el-form-item label="收款账户类型：">
			<el-select v-model="editData.accountType" class="w150" placeholder="必选" clearable>
			  <el-option v-for="(item, index) in accountTypeList" :key="index" :label="item.name" :value="item.value"/>
			</el-select>
		</el-form-item>
		<el-form-item label="商户负责人联系电话：">
		  <el-input v-model.trim="editData.merMobilePhone" placeholder="请输入商户负责人联系电话"/>
		</el-form-item>
		<el-form-item label="备注：">
		  <el-input v-model.trim="editData.remark" placeholder="非必须"/>
		</el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>
	
	<!-- 商户状态设置 -->
	<el-dialog title="商户状态设置" :visible.sync="statusData.modal" width="350px">
	  <el-form :model="statusData" >
	    <el-form-item label="商户状态：">
	    	<el-select v-model="statusData.updateFlag" class="w150" placeholder="选择" clearable>
	    	  <el-option v-for="(item, index) in merchantList" :key="index" :label="item.name" :value="item.value"/>
	    	</el-select>
	    </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="statusData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="statusSave">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 商户签约设置 -->
	<el-dialog title="商户签约设置" :visible.sync="signAcontractData.modal" width="320px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="短信验证码：">
	    <el-input v-model.trim="signAcontractData.verificationCode" placeholder="请输入短信验证码"/>
	  </el-form-item>
	  <el-form-item label="随机金额：">
	    <el-input v-model.trim="signAcontractData.randomAmount" placeholder="请输入随机金额"/>
	  </el-form-item>
	  <el-form-item label="出金卡号：">
	    <el-input v-model.trim="signAcontractData.account" placeholder="请输入出金卡号"/>
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="signAcontractData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="signAcontract">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 14、交易明细查询 -->
	<el-dialog title="交易明细查询" :visible.sync="transactionDetailsData.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionDetailsData.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionDetailsData.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionDetailsData.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionDetailsData.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionDetails">确 定</el-button>
	  </div>
	</el-dialog>
	
	<!-- 6.11	交易对账单下载 -->
	<el-dialog title="交易对账单下载" :visible.sync="transactionAccountStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="transactionAccountStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="transactionAccountStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="transactionAccountStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="transactionAccountStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="transactionAccountStatement">确 定</el-button>
	  </div>
	</el-dialog>

	<!-- 6.40	平台商户对账单下载 -->
	<el-dialog title="平台商户对账单下载" :visible.sync="platformMerchantStatementDialog.modal" width="286px">
	<el-form :model="signAcontractData" >	
	  <el-form-item label="查询开始日期：*必输">
		  
		  	    <el-date-picker
		  	        v-model="platformMerchantStatementDialog.settleDate"
		  	        style="width:250px;"
		  	        type="datetime"
		  			class="reset-clear"
		  			:clearable="false"
		  			 unlink-panels
		  	        value-format="yyyy-MM-dd"
		  	        start-placeholder="开始日期"/>  
	 <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
		
	  </el-form-item>
	  
	  <el-form-item label="查询结束日期：*必输">
	  		  
	  		  	    <el-date-picker
	  		  	        v-model="platformMerchantStatementDialog.settleDateEnd"
	  		  	        style="width:250px;"
	  		  	        type="datetime"
	  		  			class="reset-clear"
	  		  			:clearable="false"
	  		  			 unlink-panels
	  		  	        value-format="yyyy-MM-dd"
	  		  	        start-placeholder="结束日期"/>  
	  <!-- <el-input v-model.trim="transactionDetailsData.settleDate" placeholder="请选择查询日期*"/> -->
	  		
	   </el-form-item>
	   
	  <el-form-item label="压缩标识：*必选(压缩暂不支持)">
		  <el-select v-model="platformMerchantStatementDialog.zip" class="w250" clearable>
		      <el-option label="请选择" value=""/>
		      <el-option label="压缩" value="1"/><el-option label="不压缩" value="0"/>
		  </el-select>
	  <!-- <el-input v-model.trim="transactionDetailsData.zip" placeholder="请选择压缩标识*"/> -->
	  </el-form-item>
	  </el-form>
	  <div slot="footer">
	    <el-button @click="platformMerchantStatementDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="platformMerchantStatement">确 定</el-button>
	  </div>
	</el-dialog>

	
  </div>
</template>

<script>
  import {
	//二级商户入金交易 记录
	getSnhMerchantIngoldTransactionPage,
	  
	//交易明细
	getSnhTransactionDetailsPage,
	//二级商户信息分页查看
    getSnhMerchantPage,
	//二级商户标记删除
	delSnhMerchantPage,
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNew,
	//6.48	二级商户信息同步（新）
	secondaryMerchantInformationSynchronizationNew,
	//6.49	二级商户状态变更请求
	secondaryMerchantStatusChangeRequest,
	//6.5	二级商户签约确认
	signingConfirmationOfSecondaryMerchants,
	//6.45	二级商户信息查询
	secondaryMerchantInformationQuery,
	//6.35	二级商户余额查询
	secondaryMerchantBalanceQuery,
	//6.53	二级商户签约短信验证码重发
	sendMobileMessageForSubMerRequest,
	//6.26	身份验证（非页面跳转）
	authenticationNonPageJump,
	//6.24	身份验证（页面跳转）
	authenticationPageJump,
	//6、授权支付签约（银行端）
	authorizedPaymentSigningBankEnd,
	//6.16	授权支付签约（商户端）—申请
	authorizedPaymentSigningMerchantSideApplication,
	//6.17	授权支付签约（商户端）—确认
	authorizedPaymentSigningMerchantSideConfirmation,
	//6.18	授权支付签约（商户端）—验证码重发
	authorizedPaymentSigningMerchantSideVerificationCodeResend,
	//6.32	二级商户信息同步（不再支持）
	ydSnhRegSubMerchantInfoRequestOld,
	//6.44	掌银被扫支付请求
	ydSnhPalmBankIsSweptToPay,
	//6.20	授权支付签约/解约结果查询
	ydAuthorizedPaymentSigningCancelingResultQuery,
	//6.19	授权支付解约
	ydTerminationOfAuthorizedPayment,
	//6.11	对账单查询
	ydStatementQuery,
	//6.40	平台商户对账单下载
	ydPlatformMerchantStatementDownload,
	//6.27	预授权确认/取消
	ydPreAuthorizationConfirmationCancellation,
	//6.38	电子回单下载
	ydElectronicReceiptDownload,
	//6.40	鉴权交易结果查询（不再支持）
	ydAuthenticationQuery,
	//6.42	出金交易查询
	ydDepositTransactionInquiry,
	//6.46	二级商户迁移
	ydSecondaryBusinessMigration,
	//1、第三方POS对账单下载
	ydPOSThirdFileDownloadRequest,
	//2、查询POS（二级）商户T日清算金额
	ydQuerySubMerTdaySettleRequest,
	//3、第三方POS订单登记
	ydRegisterPOSOrderRequest,
	//4、第三方交易渠道订单确认
	ydThirdConfirmSendMQOrderRequest,
	//5、第三方交易渠道订单同步
	ydBatchRegisterRequest,
	//6.10	交易明细查询
	ydTransactionDetailEnquiry,
	//6.47	支出类账簿入金交易请求(活动资金)
	ydPaymentTransactionRequestOfExpenseAccountBook,
	//6.47	支出类账簿入金交易请求(垫资资金)
	ydpaymentTransactionRequestOfExpenseAccountBookAdvanceFunds,
	//6.6	单笔退款
	ydSingleRefund,
	//6.9	单笔交易查询
	ydSingleTransactionQuery
	
  } from '@/api'

   import WordImg from '@/components/WordImg.vue'

  export default {
    name: 'WordList',
    components: {WordImg},
    data () {
      return {
		//编号
		id:'',
		//二级商户编号
		subMerId:'',
		//二级商户名称
		subMerName:'',
        date: '',
        userName: '',
        tableData: [],
        tableLoading: false,
		//更多
		dialogMore:{
		modal:false,
		//更多选中操作列表中的一条
		moreRow:{}
		},
		//6.35	二级商户余额查询 查看
		dialogMerchantBalance:{
		  modal:false,
		  data:{
			  merchant:{merchantID:''},
			  trxResponse:{merchantName:''}
		  }
		},
		//6.45	二级商户信息查询
        auditShow: {
          modal: false,
          data: {
			  merchantName:'',
			  subAccountRecords:{}
		  }
        },
		//6.53	二级商户签约短信验证码重发
		signUpSMS:{
			modal: false,
			data: {}
		},
		//二级商户账薄入金交易(活动)
		secondaryMerchantsPaymentTransaction:{
			modal: false
		},	
		//二级商户账薄入金交易(垫资)
		secondaryMerchantsPaymentTransactionAdvanceFunds:{
			modal: false
		},	
		//二级商户类型
		subMerTypeList:[{name:"请选择",value:""},{name:"自然人",value:"1"},{name:"企业商户",value:"2"},{name:"个体工商户",value:"3"}],
		//法定代表人或负责人证件类型
		certificateTypeList:[{name:"请选择",value:""},{name:"身份证",value:"I"},{name:"护照",value:"P"},{name:"军官证",value:"G"},{name:"其它证件",value:"U"}],	
		//企业证件类型
		companyCertTypeList:[{name:"请选择",value:""},{name:"营业执照",value:"U"},{name:"组织机构代码证",value:"Y"},{name:"统一社会信用代码",value:"V"}],
		//收款账户类型
		accountTypeList:[{name:"请选择",value:""},{name:"借记卡",value:"401"},{name:"对公卡",value:"601"}],
		//商户状态
		merchantList:[{name:"请选择",value:""},{name:"开启",value:"6"},{name:"关闭",value:"5"},{name:"解约",value:"4"}],
		//单词新增和修改
        editData: {
          modal: false,
          userId: '',
          add: 1,
		  //二级商户名称
          subMerName: '',
		  //二级商户类型
		  subMerType:'',
		  //排序方式
		  subMerSort:'',
		  //法定代表人或负责人证件类型
		  certificateType:'',
		  //法定代表人或负责人证件编号
		  certificateNo:'',
		  //法定代表人或负责人名称
		  contactName:'',
		  //企业名称
		  companyName:'',
		  //企业证件类型
		  companyCertType:'',
		  //企业证件编号
		  companyCertNo:'',
		  //收款户名
		  accountName:'',
		  //收款账号
		  account:'',
		  //收款银行
		  bankName:'',
		  //银行预留手机号
		  mobilePhone:'',
		  //地址
		  address:'',
		  //收款账户类型
		  accountType:'',
		  //商户负责人联系电话
		  merMobilePhone:'',
		  //备注
		  remark:''
        },
		// 商户状态变更
		statusData: {
		  modal: false,
		  userId: '',
		  type: '',
		  typeName: '',
		  date: [],
		  content: ''
		},
		//商户签约设置
		signAcontractData:{
			modal: false,
			subMerId: '',
			verificationCode:'',
			randomAmount:'',
			account:''
		},
		//14 交易明细查询
		transactionDetailsData:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.11 交易对账单下载
		transactionAccountStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
		//6.40	平台商户对账单下载
		platformMerchantStatementDialog:{
			modal: false,
			//查询开始日期	必须设定，YYYY/MM/DD
			settleDate:'',
			//查询结束日期    必须设定，YYYY/MM/DD
			settleDateEnd:'',
			//压缩标识	必须设定，1：压缩，0：不压缩
			zip:''
		},
        typeList: [],
        pages: {
          page: 1,
          total: 0
        },
		imgTotal: 1,
		// 图片上传
		imgUploadData: {
		  modal: false,
		  urlList: []
		},
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
      }
    },
    created () {
      this.getSnhMerchantPageFn()
    },
    methods: {
		//6.48	二级商户信息同步（新）
		secondaryMerchantInformationSynchronizationNewFn () {
		  this.tableLoading = true
		  secondaryMerchantInformationSynchronizationNew({
			  id:this.editData.id
		  }).then(res => {
			  this.$message.success(res.data)
			  this.getSnhMerchantPageFn();
		  }).finally(() => {
		    this.tableLoading = false
		  })
		},
      getSnhMerchantPageFn() {
        this.tableLoading = true
        getSnhMerchantIngoldTransactionPage({
          pageNum: this.pages.page,
          createTime: this.date && this.date.length ? this.date[0] : '',
          updateTime: this.date && this.date.length > 1 ? this.date[1] : '',
          id: this.id,
          subMerName: this.subMerId
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
	  //6.49	二级商户状态变更请求
	  statusSave(){
		 console.info("二级商户状态变更请求",this.statusData.subMerId);
		 this.tableLoading = true
		 secondaryMerchantStatusChangeRequest({subMerId:this.statusData.subMerId,
		 updateFlag:this.statusData.updateFlag}).then(res => {
		  this.$message.success(res.data)
		  //关闭弹窗
		  this.statusData = {modal: false}
		  this.tableLoading = false
		  this.getSnhMerchantPageFn()
		 }).finally(() => {
		   this.tableLoading = false
		 }) 
	  },
	  //6.35	二级商户余额查询
	  secondaryMerchantBalanceQueryFn(subMerId){
		 console.info("二级商户余额查询",subMerId);
		 this.tableLoading = true
		 secondaryMerchantBalanceQuery({subMerId:subMerId}).then(res => {
			 //弹出二级商户余额 显示dialog
			 //更多
			 this.dialogMerchantBalance = {
			 	  modal:true,
			 	  data:res.data	  
			 }
			 console.info("6.35	二级商户余额查询 ",this.dialogMerchantBalance);	 
		  this.$message.success(res.msg)
		  this.tableLoading = false
		 }).finally(() => {
		   this.tableLoading = false
		 })  
	  },
	  //商户签约
	  signAcontract(){
		  console.info("二级商户签约",this.signAcontractData.subMerId);
		  this.tableLoading = true
		  signingConfirmationOfSecondaryMerchants({
			  subMerchantNo:this.signAcontractData.subMerId,
		      verificationCode:this.signAcontractData.verificationCode,
			  randomAmount:this.signAcontractData.randomAmount,
			  account:this.signAcontractData.account,
		  }).then(res => {
			//签约
		   this.signAcontractData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.10	交易明细查询
	  transactionDetails(){
		  this.tableLoading = true
		  ydTransactionDetailEnquiry({
					  //查询日期	必须设定，YYYY/MM/DD
		  			  settleDate:this.transactionDetailsData.settleDate,
					  //查询结束日期 必须设定，YYYY/MM/DD
					  settleDateEnd:this.transactionDetailsData.settleDateEnd,
					  //压缩标识	必须设定，1：压缩，0：不压缩
		  			  zip:this.transactionDetailsData.zip
		  }).then(res => {
		   this.transactionDetailsData = { modal: false }
		   this.$message.success(res.msg)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //6.11 交易对账单下载
	  transactionAccountStatement(){
		  this.tableLoading = true
		  			ydStatementQuery({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.transactionAccountStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.transactionAccountStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.transactionAccountStatementDialog.zip
		  			}).then(res => {
						this.transactionAccountStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.40	平台商户对账单下载
	  platformMerchantStatement(){
		  //6.40	平台商户对账单下载
		  			this.tableLoading = true
		  			ydPlatformMerchantStatementDownload({
		  				//查询日期	必须设定，YYYY/MM/DD
		  				settleDate:this.platformMerchantStatementDialog.settleDate,
		  				//查询结束日期 必须设定，YYYY/MM/DD
		  				settleDateEnd:this.platformMerchantStatementDialog.settleDateEnd,
		  				//压缩标识	必须设定，1：压缩，0：不压缩
		  				zip:this.platformMerchantStatementDialog.zip
		  			}).then(res => {
						this.platformMerchantStatementDialog = { modal: false }
		  				this.$message.success(res.data)
		  				this.getSnhMerchantPageFn();
		  			}).finally(() => {
		  			  this.tableLoading = false
		  			})
	  },
	  //6.45	二级商户信息查询
	  secondaryMerchantInformationQueryFn(){
		  console.info("二级商户信息查询",this.auditShow.subMerId);
		  this.tableLoading = true
		  secondaryMerchantInformationQuery({
		  			  subMerId:this.auditShow.subMerId
		  }).then(res => {
		   this.auditShow.data = res.data;
		   if(res.data.accountRecords.length > 0){
		   this.auditShow.data.subAccountRecords = res.data.accountRecords[0]
		   }
		   //console.info(this.auditShow.data.subAccountRecords,"=======") //JSON.parse()
		   //this.$message.success(res)
		   this.tableLoading = false
		  }).finally(() => {
		    this.tableLoading = false
		  }) 
	  },
	  //二级商户标记删除
	  delSnhMerchantPageFn(id) {
		  console.info("二级商户标记删除",id);
	    this.tableLoading = true
	    delSnhMerchantPage({id:id}).then(res => {
	     this.$message.success(res.msg)
	     this.getSnhMerchantPageFn()
	    }).finally(() => {
	      this.tableLoading = false
	    })	},
	  editBtn(t,row) {
		  //1新增 2修改 3列表查看图片 4查看里面的图片放大 5删除 6状态变更
		  if(t == 1){
			 this.editData = {
			   modal: true,
			   userId: '',
			   add: 1,
			   word: '',
			   chinese: '',
			   picture: []
			 }
		  }else if(t == 2){
			  console.info(row,"修改商户")
			  this.editData = {
			    modal: true,
			    id: row.id,
			    add: 2,
			    //二级商户名称
			    subMerName: row.subMerName,
			    //二级商户类型
			    subMerType:row.subMerType,
			    //排序方式
			    subMerSort:row.subMerSort,
			    //法定代表人或负责人证件类型
			    certificateType:row.certificateType,
			    //法定代表人或负责人证件编号
			    certificateNo:row.certificateNo,
			    //法定代表人或负责人名称
			    contactName:row.contactName,
			    //企业名称
			    companyName:row.companyName,
			    //企业证件类型
			    companyCertType:row.companyCertType,
			    //企业证件编号
			    companyCertNo:row.companyCertNo,
			    //收款户名
			    accountName:row.accountName,
			    //收款账号
			    account:row.account,
			    //收款银行
			    bankName:row.bankName,
			    //银行预留手机号
			    mobilePhone:row.mobilePhone,
			    //地址
			    address:row.address,
			    //收款账户类型
			    accountType:row.accountType,
			    //商户负责人联系电话
			    merMobilePhone:row.merMobilePhone,
			    //备注
			    remark:row.remark
			  }
		  }else if(t == 3) {
	      this.imgPreData = {
	        modal: true,
	        url: row.picture
	      }
	    }else if(t == 4) {
	      this.imgPreData = {
	        modal: true,
	        url: this.auditShow.data.picture
	      }
	    }else if(t == 5){
			this.$confirm(`确认要删除吗`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			  }).then(() => {
				 let id =  row.id
			     this.delSnhMerchantPageFn(id);
			});
		}else if(t == 6){
			//商户状态变更
		this.statusData = {
		  modal: true,
		  subMerId: row.subMerId,
		  updateFlag: row.state,
		  date: [],
		  content: ''
		}
		}else if(t == 7){
			//签约
			this.signAcontractData = {
				modal: true,
				subMerId: row.subMerId,
				verificationCode:'',
				randomAmount:'',
				account:row.account
			}
		}else if(t == 8){
			//6.45	二级商户信息查询
			this.auditShow = {modal: true, subMerId: row.subMerId}
			this.secondaryMerchantInformationQueryFn()
		}else if(t == 9){
			//6.53	二级商户签约短信验证码重发
			this.signUpSMS = {
				modal: true,
				 subMerId: row.subMerId,
				 subMerchantAccNo:row.account
			}
		}else if(t == 10){
			//6.35	二级商户余额查询
			console.info("6.35	二级商户余额查询",row.subMerId)
			this.secondaryMerchantBalanceQueryFn(row.subMerId)
		}else if(t == 11){
			//6.26	身份验证（非页面跳转）
			console.info("6.26	身份验证（非页面跳转）");
			this.tableLoading = true
			authenticationNonPageJump({ 
				//客户类型
				customType:row.customType,
				//客户姓名
				clientName:row.accountName,
				//银行帐号
				accNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//手机号
				mobileNo:row.merMobilePhone,
				//网银客户号
				customNo:'',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 12){
			//6.24	身份验证（页面跳转）
			console.info("6.24	身份验证（页面跳转）");
			this.tableLoading = true
			authenticationPageJump({ 
				//客户类型
				customType:row.customType,
				//银行帐号
				bankCardNo:row.account,
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 13){
			//6、授权支付签约（银行端） 
			console.info("6、授权支付签约（银行端）");
			this.tableLoading = true
			authorizedPaymentSigningBankEnd({ 
				//证件号码
				certificateNo:row.certificateNo,
				//证件类型
				certificateType:row.certificateType,
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//卡类型
				cardType:'A',
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 14){
			//6.16	授权支付签约（商户端）—申请
			console.info("6.16	授权支付签约（商户端）—申请");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideApplication({ 
				//交易渠道
				paymentLinkType:'1',
				//客户编号
				merCustomNo:row.subMerId,
				//签约卡号
				cardNo:row.account,
				//卡类型
				cardType:'A',
				//手机号
				mobileNo:row.mobilePhone,
				//证件类型
				certificateType:row.certificateType,
				//证件号码
				certificateNo:row.certificateNo,
				//客户姓名
				accName:row.accountName
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 15){
			//6.17	授权支付签约（商户端）—确认
			console.info("6.17	授权支付签约（商户端）—确认");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideConfirmation({ 
				//交易编号	
				orderNo:'3GECEP01223743931840',
				//验证码	
				verifyCode:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if(t == 16){
			//6.18	授权支付签约（商户端）—验证码重发
			console.info("6.18	授权支付签约（商户端）—验证码重发");
			this.tableLoading = true
			authorizedPaymentSigningMerchantSideVerificationCodeResend({ 
				//交易编号	
				orderNo:'1',
				//签约卡号	
				cardNo:row.account
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 17 ){
			console.info("更多",row)
			//更多
			this.dialogMore = {
				  modal:true,
				  moreRow:row	  
			}
		}else if( t == 18 ){
			//同步old
			this.tableLoading = true
			ydSnhRegSubMerchantInfoRequestOld({ 
				//编号
				id: row.id
			}).then(res => {
			 this.$message.success(res.data)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 19 ){
			//6.44	掌银被扫支付请求
			this.tableLoading = true
			ydSnhPalmBankIsSweptToPay({ 
				//编号
				id: row.id,
				//二级商户编号
				subMerId:row.subMerId,
				//支付二维码信息
				payCode:6235613048944148431
			}).then(res => {
			 this.$message.success(res.msg)
			 this.tableLoading = false
			}).finally(() => {
			  this.tableLoading = false
			}) 
		}else if( t == 20 ){
			//6.48	二级商户信息同步（新）
			this.editData.id = row.id
			this.secondaryMerchantInformationSynchronizationNewFn()
		}else if( t == 21 ){
			//6.20	授权支付签约/解约结果查询
			this.tableLoading = true
			ydAuthorizedPaymentSigningCancelingResultQuery({
				//签约编号
				orderNo:row.id
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 22 ){
			//6.19	授权支付解约
			this.tableLoading = true
			ydTerminationOfAuthorizedPayment({
				//交易编号
				orderNo:row.id,
				//签约编号
				agentSignNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 23 ){
			// 14、交易明细查询 弹出选择框
			this.transactionDetailsData = { modal: true }
		}else if( t == 24 ){
			//6.11	对账单查询
			this.transactionAccountStatementDialog = { modal: true }
		}else if( t == 25 ){
			//6.40	平台商户对账单下载
			this.platformMerchantStatementDialog = { modal: true }
		}else if( t == 26 ){
			//6.27	预授权确认/取消
			this.tableLoading = true
			ydPreAuthorizationConfirmationCancellation({
				//交易类型
				operateType:'',
				//交易日期
				orderDate:'',
				//交易时间
				orderTime:'',
				//交易编号
				orderNo:'',
				//原交易编号
				originalOrderNo:'',
				//币种
				currencyCode:'',
				//金额
				orderAmount:'',
				//手续费金额
				fee:'',
				//附言
				merchantRemarks:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 27 ){
			//6.38	电子回单下载
			this.tableLoading = true
			ydElectronicReceiptDownload({
				//二级商户编号
				subMerchantNo:'',
				//支付订单编号
				orderNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 28 ){
			//6.40	鉴权交易结果查询（不再支持）
			this.tableLoading = true
			ydAuthenticationQuery({
				//鉴权交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 29 ){
			//6.42	出金交易查询
			this.tableLoading = true
			ydDepositTransactionInquiry({
				//外转（出金）交易编号	必须设定
				transferNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 30 ){
			//二级商户迁移
			this.tableLoading = true
			ydSecondaryBusinessMigration({
				//源平台商户号 必须设定
				fromMerchantNo:'',
				//待迁移二级商户编号   必须设定
				subMerchantNo:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 31 ){
			//第三方POS对账单下载
			this.tableLoading = true
			ydPOSThirdFileDownloadRequest({
				//二级商户号
				subMerchantID:'',
				//对账单下载日期
				fileDate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 32){
			//查询POS（二级）商户T日清算金额 
			this.tableLoading = true
			ydQuerySubMerTdaySettleRequest({
				//二级商户号
				subMerchantNo:'',
				//清算日期
				trxDate:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 33 ){
			//3、第三方POS订单登记
			this.tableLoading = true
			ydRegisterPOSOrderRequest({
				//二级商户号
				subMerchantNo:'',
				//订单号
				orderNo:'',
				//订单日期
				orderDate:'',
				//序列号
				sequenceNo:'',
				//订单金额
				amount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 34 ){
			//4、第三方交易渠道订单确认 
			this.tableLoading = true
			ydThirdConfirmSendMQOrderRequest({
				//订单号
				orderNo:'',
				//确认订单号
				newOrderNo:'',
				//确认金额
				orderAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 35 ){
			//5、第三方交易渠道订单同步
			this.tableLoading = true
			ydBatchRegisterRequest({
				//批次号
				batchNo:'',
				//批次日期
				batchDate:'',
				//批次日期
				batchTime:'',
				//本批次笔数
				batchCount:'',
				//本批次金额
				batchAmount:'',
				//交易总笔数
				totalCount:'',
				//交易总金额
				totalAmount:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 36 ){
			//6.6	单笔退款
			this.tableLoading = true
			ydSingleRefund({
				//商户退款账号 非必须
				merRefundAccountNo:'',
				//商户退款名		非必须
				merRefundAccountName:'',
				//支付订单号		必须设定
				orderNo:'',
				//退款交易编号	必须设定
				newOrderNo:'',
				//退款金额		必须设定
				trxAmount:'',
				//维权退款标志        非必须，0:普通退款，1:维权退款
				refundType:'',
				//附言			非必须
				merchantRemarks:'',
				//平台商户担保支付退款资金来源    非必须 ，1：担保账簿 2:二级商户账簿 3：退款账簿
				merRefundAccountFlag:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 37 ){
			//6.9	单笔交易查询
			this.tableLoading = true
			ydSingleTransactionQuery({
				// 交易类型		必须设定,ImmediatePay：直接支付
				// PreAuthPay：预授权支付
				// DividedPay：分期支付
				// AgentPay：授权支付
				// Refund：退款
				// DefrayPay：付款
				// PreAuthed：预授权确认
				// PreAuthCancel：预授权取消
				payTypeID:'',
				//交易编号		必须设定
				orderNo:'',
				//是否查询详细信息	必须设定, 0：状态查询； 1：详细查询
				queryDetail:''
			}).then(res => {
				this.$message.success(res.data)
				this.getSnhMerchantPageFn();
			}).finally(() => {
			  this.tableLoading = false
			})
		}else if( t == 49 ){
			//企业网银充值(活动)
			//二级商户账薄支出类入金请求
			this.secondaryMerchantsPaymentTransaction = {
			modal:true,
			//二级商户编号
			amountOfMoney:this.amountOfMoney
			}
		}else if( t == 50 ){
			//企业网银充值(垫资)
			//二级商户账薄支出类入金请求
			this.secondaryMerchantsPaymentTransactionAdvanceFunds = {
			modal:true,
			//二级商户编号
			amountOfMoney:this.amountOfMoney
			}
		}
	},
	//二级商户账薄支出类入金请求(活动)
	secondaryMerchantsPaymentTrans(){
		//6.47	支出类账簿入金交易请求
		this.tableLoading = true
		ydPaymentTransactionRequestOfExpenseAccountBook({
			//订单金额
			orderAmount:this.secondaryMerchantsPaymentTransaction.amountOfMoney,
			//订单描述
			orderDesc:'支出活动账簿入金',
			// 支付接入方式 必须设定，
			// 1：internet网络接入
			// 2：手机网络接入
			// 3：数字电视网络接入
			// 4：智能客户端
			paymentLinkType:'1',
			//附言
			merchantRemarks:'附言'
		}).then(res => {
			if( res.code === 200 ){
				window.location = res.data
			}else{
				this.$message.success(res.msg)
			}
			this.getSnhMerchantPageFn();
		}).finally(() => {
		  this.tableLoading = false
		})
	},
	//二级商户账薄支出类入金请求(垫资)
	secondaryMerchantsPaymentTransAdvanceFunds(){
		//6.47	支出类账簿入金交易请求
		this.tableLoading = true
		ydpaymentTransactionRequestOfExpenseAccountBookAdvanceFunds({
			//订单金额
			orderAmount:this.secondaryMerchantsPaymentTransactionAdvanceFunds.amountOfMoney,
			//订单描述
			orderDesc:'支出垫资账簿入金',
			// 支付接入方式 必须设定，
			// 1：internet网络接入
			// 2：手机网络接入
			// 3：数字电视网络接入
			// 4：智能客户端
			paymentLinkType:'1',
			//附言
			merchantRemarks:'附言'
		}).then(res => {
			if( res.code === 200 ){
				window.location = res.data
			}else{
				this.$message.success(res.msg)
			}
			this.getSnhMerchantPageFn();
		}).finally(() => {
		  this.tableLoading = false
		})
	},
	//二级商户信息保存
	SecondaryMerchantsSynchronizeNewFn(){
	this.tableLoading = true
	SecondaryMerchantsSynchronizeNew({ 
		//编号
		id:this.editData.id,
		//二级商户编号
		subMerId:this.editData.subMerId,
		//二级商户名称
		subMerName: this.editData.subMerName,
		//二级商户类型
		subMerType:this.editData.subMerType,
		//排序方式
		subMerSort:this.editData.subMerSort,
		//状态 0:关闭 1:正常
		status:1,
		//法定代表人或负责人证件类型
		certificateType:this.editData.certificateType,
		//法定代表人或负责人证件编号
		certificateNo:this.editData.certificateNo,
		//法定代表人或负责人名称
		contactName:this.editData.contactName,
		//企业名称
		companyName:this.editData.companyName,
		//企业证件类型
		companyCertType:this.editData.companyCertType,
		//企业证件编号
		companyCertNo:this.editData.companyCertNo,
		//收款户名
		accountName:this.editData.accountName,
		//收款账号
		account:this.editData.account,
		//收款银行
		bankName:this.editData.bankName,
		//银行预留手机号
		mobilePhone:this.editData.mobilePhone,
		//地址
		address:this.editData.address,
		//收款账户类型
		accountType:this.editData.accountType,
		//商户负责人联系电话
		merMobilePhone:this.editData.merMobilePhone,
		//备注
		remark:this.editData.remark
	}).then(res => {
	 this.$message.success(res.msg)
	 this.tableLoading = false
	 this.editData.modal = false
	 //刷新
	 this.getSnhMerchantPageFn() 
	}).finally(() => {
	  this.tableLoading = false
	}) 
	},
	//6.53	二级商户签约短信验证码重发
	signUpSMSBtn(){
		console.info("二级商户签约短信验证码重发",this.signUpSMS.subMerId);
		this.tableLoading = true
		sendMobileMessageForSubMerRequest({
					  subMerId:this.signUpSMS.subMerId,
					  subMerchantAccNo:this.signUpSMS.subMerchantAccNo
		}).then(res => {
		 this.$message.success(res.msg)
		 this.tableLoading = false
		}).finally(() => {
		  this.tableLoading = false
		}) 
	},
	addBtn (t) {
	  if (this.editData.add == 1) {
		  //添加
		  this.SecondaryMerchantsSynchronizeNewFn()
	  } else {
		  //修改
		this.SecondaryMerchantsSynchronizeNewFn()
	  }
	},
	uploadSave() {
	  if (this.imgUploadData.urlList && this.imgUploadData.urlList.length) {
	    addImage(this.imgUploadData.urlList.map(item => ({pictureUrl: item}))).then(res => {
	      this.$message.success(res.data)
	      this.imgUploadData.modal = false
	      this.getImagePageFn()
	    })
	  }
	},
      pageChange (val) {
        this.pages.page = val
        this.getSnhMerchantPageFn()
      }
    }
  }
</script>

<style scoped>
  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .type-ul {
    margin-top: 10px;
    max-height: 400px;
    overflow: auto;
  }

  .type-li {
    display: flex;
    align-items: center;
    line-height: 40px;
    border-bottom: 1px solid #d0d3da;
  }

  .type-li p {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
